import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum GuestInvoiceAction {
  charge = 'charge',
  markVoid = 'mark_void',
}

export default class GuestInvoiceActionModel extends Model {
  @attr('string') action!: GuestInvoiceAction;

  @belongsTo('guest-invoice', { async: false, inverse: null })
  guestInvoice!: ModelRegistry['guest-invoice'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'guest-invoice-action': GuestInvoiceActionModel;
  }
}
